import * as actionTypes from '../actions/actionsTypes';
import { updateObject } from '../utility';

const initialState = {
   users: [],
    loading: false
}

const fetchEmailManageStart = (state, action) => {
    return updateObject(state, {
        loading: true,
    });
}

const fetchEmailManageSuccess = (state, action) => {
    return updateObject(state, {
        users: action.users,
        loading: false,
    });
}

const fetchEmailManageFail = (state, action) => {
    return updateObject(state, {
        loading: false,
    })
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_EMAILMANAGE_START: return fetchEmailManageStart(state, action);
        case actionTypes.FETCH_EMAILMANAGE_SUCCESS: return fetchEmailManageSuccess(state, action);
        case actionTypes.FETCH_EMAILMANAGE_FAIL: return fetchEmailManageFail(state, action);
        
        default: return state;
    }
}

export default reducer;